export default {
    //search-company
    people: "人物",
    clearAll: "すべてクリア",
    searchProspects: "検索...",
    //actions
    isFoundIn: "に保存されています",
    isNotFoundWithinAnyLists: "どのリストにも見つかりません",
    l: "リスト",
    remove: "削除",
    saveToLists: "リストに保存",
    DeleteFailed: "削除失敗",
    //delete dialog
    areYouSureYouWantToDeleteThisRecord:
      "この記録を削除してもよろしいですか？",
    proceedingWithDeletionWillResultInPermanentRemovalOfTheList:
      "削除を続行すると、リストは完全に削除されます",
    byCancelingYouEnsureThatNoListsWillBeRemoved:
      "キャンセルすると、リストは削除されません",
    //export dialog
    holdOnWereGeneratingYourExport: "お待ちください。エクスポートを生成中です",
    UseThisButtonOnlyIfYouWishToCancelYourAction:
      "このボタンは、アクションをキャンセルしたい場合にのみ使用してください",
    //save search pop
    saveSearch: "検索を保存",
    newSaveSearch: "新しい検索を保存",
    UpdateSavedSearch: "保存した検索を更新",
    enterNewSearchName: "新しい検索名を入力",
    visibility: "公開設定",
    manageWhoCanSeeYourSavedSearch: "保存した検索を誰が見ることができるかを管理する",
    private: "非公開",
    onlyYouCanSeeYourSavedSearch: "あなただけが保存した検索を見ることができます",
    everyoneCanSeeYourSavedSearch: "全員が保存した検索を見ることができます",
    pinSavedSearch: "保存した検索をピン留め",
    findSavedSearch: "保存した検索を探す",
    enterSavedSearchName: "保存した検索名を入力",
    duplicate: "複製",
    update: "更新",
    enterATitleForYourCard: "カードのタイトルを入力",
    enterYourCardNumber: "カード番号を入力",
    digit: "3桁",
    provideYourCompleteAddress: "完全な住所を入力してください",
    selectYourCountry: "国を選択",
    //add credits pop
    ClickTheButtonBelowToAddMoreCredits:
      "以下のボタンをクリックしてクレジットを追加してください！",
    PleaseEnterTheAmountYouLikeToTopUpToYourCredit:
      "クレジットにチャージしたい金額を入力してください",
    //companyLink\contactBtn\functionBtn\default
    more: "その他",
    verified: "確認済み",
    GetEmailSuccessfully: "Eメールを正常に取得しました",
    CopySuccessfully: "正常にコピーされました",
    recorded: "記録済み",
    implement: "実装",
    sequence: "シーケンス",
    of: "の",
    toAssistYouEffectivelyWeRequireFurtherDetailsAbout:
      "効果的にサポートするために、検索の好みについてさらに詳細が必要です。左側のパネルのフィルターオプションを使用して、希望する条件を指定してください。これにより、検索結果を絞り込み、要件を満たすターゲットを絞った個人を提供できます。",
  
    //filter
    all: "すべて",
    my: "自分",
    team: "チーム",
    lists: "保存済みリスト",
    employees: "従業員",
    technologies: "テクノロジー",
    socialmedia: "ソーシャルメディア",
    enterSocialMedia: "ソーシャルメディアを入力",
    noResultsFound: "結果が見つかりません",
    searchCompanies: "企業を検索",
    filters: "フィルター",
    enterCompanies: "企業を入力",
    accountHqLocation: "アカウント本社所在地",
    CityStateCountryZIP: "市区町村/都道府県/国/郵便番号",
    enterLocations: "場所を入力",
    revenue: "収益",
    chooseARangeOfRevenue: "収益の範囲を選択",
    ofRevenueIsUnknown: "の収益は不明",
    technology: "テクノロジー",
    category: "カテゴリー",
    categories: "カテゴリー",
    enterCategories: "カテゴリーを入力",
    enterTechnologies: "テクノロジーを入力",
    enterIndustries: "産業を入力",
    employee: "従業員",
    predefinedRange: "事前定義された範囲",
    ofEmployeesIsUnknown: "の従業員は不明",
    enterNames: "名前を入力",
    jobTitle: "役職",
    searchForAJobTitle: "役職を検索",
    founded: "設立",
    chooseARangeOfFoundedTime: "設立期間を選択",
    from: "から",
    to: "まで",
    specialties: "専門分野",
    enterSpecialties: "専門分野を入力",
    location: "所在地",
    excludedLocationsLabel: '所在地 [除外]',
    location_exclude: "[除外]",
    total: "合計",
    department: "部門",
    EnterDepartments: "部門を入力",
    JobTitle: "役職",
    EnterJobTitles: "役職を入力",
    ManagementLevel: "管理職レベル",
    EnterManagementLevels: "管理職レベルを入力",
    AccountHQ: "アカウント本社",
    ContactHQ: "連絡先本社",
    departmentFunction: "部門機能",
    EnterJobFunctions: "職務を入力",
    enterNamesAndPressTheEnterKey: "名前を入力してEnterキーを押す...",
    EnterJobTitlesAndPressTheEnterLKey:
      "役職を入力してEnterキーを押す...",
    contactDetails: "連絡先情報",
    filterMustContain: "次を含む",
    filterWorkEmail: "仕事用メールアドレス",
    filterPersonalEmail: "個人用メールアドレス",
    filterPhone: "電話番号",
    filterHasEmail: "メールアドレスあり",
    filterHasPhone: "電話番号あり",
    filterExcludeWithoutContact: "連絡先情報がない連絡先を除外",
    pleaseSelectRange: "範囲を選択してください",
    exclude_locations: "場所を除外",
    filterExclude: "除外",
  
    //table
    selectAllCompanies: "すべての企業を選択",
    selected: "選択済み",
    export: "エクスポート",
    industry: "産業",
    keywords: "キーワード",
    companyLocation: "企業所在地",
    action: "アクション",
    contact: "連絡先",
    Title: "役職",
    clearSelection: "選択をクリア",
    selectNumberOfCompanies: "企業の数を選択",
    maxCompanies: "最大企業数",
    youCanOnlySelectAMaximumOf25Companies:
      "最大25社までしか選択できません。",
    UpgradeYourPlanNow: "今すぐプランをアップグレード！",
    viewPlans: "プランを表示",
    applySelection: "選択を適用",
    selectNumberOfProspects: "見込み客の数を選択",
    maxProspects: "最大見込み客数",
    maxProspectsPerCompany: "企業ごとの最大見込み客数",
    youCanOnlySelectAMaximumOf25Prospects:
      "最大25人の見込み客までしか選択できません。",
    PleaseSelectTheDataToBeExported: "エクスポートするデータを選択してください",
    overview: "概要",
    genericContacts: "一般的な連絡先",
    size: "規模",
    contactLocation: "連絡先所在地",
    pleaseSelectItems: "アイテムを選択してください",
    specialties: "専門分野",
    moreSpecialty: "+{count}件",


    // 新UI
    prospectsSearch: "見込み客検索",
    companiesSearch: "企業検索",
    savedSearches: "保存した検索",
    savedLists: "保存したリスト",


    // saved list and saved searches
    sortAndFilter: "並び替えとフィルター",
    sortBy: "並び替え",
    filterAll: 'すべて',
    filterPrivate: '非公開',
    filterTeam: 'チーム',
    searchSavedLists: "保存したリストを検索",
    savedSearchName: "保存した検索名",
    noFilteringOptionsAvailable: "フィルタリングオプションはありません",
    manageWhoCanSeeThisSearch: "この検索を誰が見れるか管理する",
    noSavedSearchesMatchYourQuery: "検索条件に一致する保存済みの検索はありません。別のキーワードを試すか、スペルを確認してください。",
    onlyU: "あなただけ",
    anyoneOnTheTeam: "チームの誰でも",
    createNewList: "新しいリストを作成",
    groupTeam: "チーム",
    groupPersonal: "個人",
    manageWhoCanViewThisList: "このリストを誰が見れるか管理する",
    enterAListName: "リスト名を入力",
    savedList: "保存したリスト",
    listName: "リスト名",
    saveContactsTo: "連絡先を保存先",
    contactEmails: "連絡先Eメール",
    contactPhones: '連絡先電話番号',
    unlockContactDetails: "連絡先の詳細を解除",
    getContactInfo: '連絡先情報を取得',
    contactDetailsAreOnTheWay: "連絡先の詳細がまもなく届きます",
    noDataAvailable: '利用可能なデータなし',
    accessEmails: "Eメールにアクセス",
    accessPhoneNumber: "電話番号にアクセス",
    accessPhoneNumbersAndEmails: "電話番号とEメールにアクセス",

    redemptionComplete: "償還完了！",
    bulkRedeemProcessing: "一括償還を処理中...",
    notifyMeWhenCompleted: "完了時に通知する",
    expectedTime: "予想時間：",
    redeemSeconds: "{count}秒",
    redeemLoading: "読み込み中...",
    estimatedCharge: "推定費用: {count}クレジット",


    estimatedCost: "推定費用: {count}クレジット",
    finalChargeBasedOnRequest: "最終的な費用は、リクエストの完了状況に基づいて変動する場合があります",
    showLess: "少なく表示",
    exportLeadsToCSV: "リードをCSVにエクスポート",
    exportComplete: "エクスポート完了！",
    exporting: "エクスポート中...",
    pleaseSelectTheFieldsThatNeedToBeExported: "エクスポートが必要なフィールドを選択してください",
    exportLeads: "あなたは{count}件のリードをエクスポートしようとしています。選択した数によっては、しばらく時間がかかる場合があります。|あなたは{count}件のリードをエクスポートしようとしています。選択した数によっては、しばらく時間がかかる場合があります。",
    dataFieldsToInclude: "含めるデータフィールド",
    savedListRecords: '{count}件の記録',
    deleteList: "リストを削除",
    actionCannotBeUndone: "このリストを削除してもよろしいですか？この操作は元に戻せません。",
    selectedContactsNumber: "選択された連絡先の{count}件",
    btnSave: "保存",
    btnUnsave: "保存解除",
    specialties: "専門分野",
    upgradeNowToAccessMore: "今すぐアップグレードして、さらに多くの機能にアクセスしましょう！",
    selectCompanyNumber: "現在のプランでは、最大{count}社まで選択できます。|現在のプランでは、最大{count}社まで選択できます。",
    selectPeopleNumber: "現在のプランでは、最大{count}人の見込み客まで選択できます。|現在のプランでは、最大{count}人の見込み客まで選択できます。",
    selectAll: "すべて",
    selectThisPage: 'このページ',
    selectCustomize: 'カスタマイズ',
    pleaseSelectTheFilteringType: "フィルタリングタイプを選択してください",
    theQuantityCannotBeZero: '数量は0にできません',
    filterSearch: "フィルター検索",
    view: "表示",
    deleteSavedSearch: "保存した検索を削除",
    deleteThisSavedSearch: "この保存した検索を削除してもよろしいですか？この操作は元に戻せません。",
    createASequenceToStartAutomatingYourOutreach: "アウトリーチの自動化を開始するには、シーケンスを作成し、準備ができたらここにアイテムを追加してください。",
    unsaveThemFromHere: "選択した見込み客が既に保存されている場合、ここから保存を解除できます。",
    createAListToSaveAndOrganizeProspects: "見込み客を保存および整理するためのリストを作成する",
    savedFilters: "保存済みのフィルター",
    viewResults: "検索結果を見る",

    // search empty
    resultNoResultsFound: "結果が見つかりません",
    noContactsThatMatchYourSearch: "検索またはフィルターに一致するものはありません。<br />フィルターを変更するか、別のキーワードを使用してみてください。",
    requestTimedOut: "リクエストがタイムアウトしました",
    theServerIsCurrentlyBusy: "サーバーが現在混雑しており、<br />結果を読み込むことができませんでした。ページを更新してみてください。",
    btnRefresh: "更新",

    // tooltip
    tooltipRedeemEmail: "Eメールを償還",
    tooltipRedeemPhone: "電話番号を償還",
    tooltipRedeemEmailAndPhone: "すべて償還",
    tooltipSearchPeople: "選択した企業から人物を探す",
    tooltipFilter: "フィルター",
    tooltipSequence: "ワークフロー",
    tooltipSave: "リストに保存",
    textFindPeople: "「人を探す」",

    // recent mode
    recentMode: "最近のモード",
    tryRealTimeAgain: "リアルタイムを再試行",
    realTimeResultsAreTemporarilyPaused: 'API制限により、リアルタイムの結果は一時的に停止されています',


    // company-detail
    companies: "企業",

    // recent search
    popularUseCases: "人気のユースケース",
    skipTheGuesswork: " 勘に頼るのはやめて、人気のフィルターの組み合わせから始めましょう。",
    labelRecentSearches: "最近の検索",
    labelRecentSavedFilters: "最近保存したフィルター",
    useThisFilterSetup: "このフィルター設定を使用",
    startByApplyingFilters: "関連する連絡先や企業を見つけるには、まず左側のパネルからフィルターを適用してください。",


    // 
    k: 'k',

  filterAdvertisementStartDateSubTitle: "広告開始日期間",
  filterAdvertisementEndDateSubTitle: "広告終了日期間",
  filterAdvertisementSearchTermsSubTitle: "広告検索語",
  filterAdvertisementExcludeTargetLocation: "対象地域を除外",
  active_filters_count: "1 件のアクティブフィルター | {count} 件のアクティブフィルター",
  company_list: "企業リスト",
  filter_presets: "フィルタープリセット",
  my_list: "マイリスト",
  company_profile: "企業プロフィール",
  people_workforce: "人材・労働力",
  technology_presence: "テクノロジーとプレゼンス",
  saved_searches_count: "{count} 件保存済み",
  filterJobExcludeLocation: "除外する勤務地",

  enter_keywords: "キーワードを入力",
  filter_keywords_description_search_title: "説明内を検索",
  filter_keywords_description_search_tooltip: "企業説明内のキーワードを検索します。",
  filter_places_description_search_title: "特定の場所を除外",
  filter_places_description_search_tooltip: "検索結果から特定の場所を除外します。",
  enter_places: "場所を入力",
  enterAdvertisementSearchTerms: "検索語を入力してEnterキーを押す...",
  people_list: "人材リスト",
  clear: "クリア",
  places: "場所",

  expand_filters: "フィルターを開く",
  collapse_filters: "フィルターを閉じる",
};
